import { createContext } from "react";

interface ThemeContextInterface {
  switchTheme: () => void;
  setAutoTheme: () => void;
  currentTheme: string;
}

export const ThemeContext = createContext<ThemeContextInterface | null>(null);
